import React, { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";

import { MetaMaskContext } from '../context/mm-context'

import Button from "./shared/Button";

const Header = () => {

    // retrieve site context
    const ctx = useContext(MetaMaskContext);

    // get the network details from the site context
    const { networkId, networkName } = ctx.network;

    // set some state
    const [feedback, setFeedback] = useState();
    const [isConnecting, setIsConnecting] = useState(false);

    // connect to metamask
    const connect = async () => {

        // ensure the feedback is blank
        setFeedback();

        // check that metamask is installed
        if (!window.ethereum) return setFeedback(<>MetaMask not found! <a href="https://metamask.io/download/" target="_blank">click here to install it</a>. if you've just installed it try refreshing the page.</>)

        const errorTimeout = setTimeout(() => { setFeedback(<>This is taking a while, please ensure you are logged into MetaMask.</>) }, 10000);
        try {

            // set loading state
            setIsConnecting(true);

            // get the provider from metamask
            const provider = new ethers.providers.Web3Provider(window.ethereum);

            // open metamask window
            await provider.send("eth_requestAccounts", []);
            clearTimeout(errorTimeout);

            // get the signer
            const signer = provider.getSigner();

            // extract the chain ID and name
            const { chainId } = await provider.getNetwork()

            // if the chain is wrong alert the user
            if (chainId !== networkId) throw { code: 99999, message: `Please ensure you are connected to the ${networkName} network in MetaMask` };

            // get the connected wallet address
            const walletAddress = await signer.getAddress();
            ctx.address(walletAddress);

            // return ens address
            const ensAddress = await provider.lookupAddress(walletAddress);
            ctx.ens(ensAddress);

            // define the contract
            const contract = new ethers.Contract(ctx.contractAddress, ctx.abi, signer);
            ctx.contract(contract);

            // set the isConnected to true
            ctx.authenticate();
            setIsConnecting(false);

        } catch (err) {
            let message;
            if (err.code === 99999) {
                message = err.message;
            } else if (err.code === 4001) {
                message = 'Sign-in request cancelled by user';
            } else {
                message = 'Something went wrong. Maybe try refreshing the page?';
            }
            setFeedback(message);
            clearTimeout(errorTimeout);
            setIsConnecting(false);
        }
    }

    // monitor metamask for changes
    useEffect(() => {
        if (ctx.isConnected && window.ethereum) {
            window.ethereum.on('accountsChanged', () => {
                ctx.disconnect();
            });
            window.ethereum.on('chainChanged', () => {
                ctx.disconnect();
            });
        }
    });

    return (
        <>
            {!ctx.isConnected &&
                <>
                    <Button
                        content={!isConnecting && "CONNECT" || "CONNECTING..."}
                        size="btn-lg"
                        styles="my-4"
                        onClick={connect}
                        disabled={isConnecting ? 'disabled' : ''}
                        style={{ width: "300px" }}
                        colour="btn-tota-dark"
                    />
                    {feedback &&
                        <div className="alert alert-tota-dark mx-auto" role="alert" style={{ width: "300px" }}>
                            {feedback}
                        </div>
                    }
                    <div className="bg-tota-blur small rounded text-center mt-2 mb-2 p-2 mx-auto" role="alert" style={{ maxWidth: "300px" }}>
                        In MetaMask please ensure you are connected to the correct network ({networkName}) and using the desired address, then click CONNECT
                    </div>
                </>
            }
        </>
    )
}

export default Header